import { type FilterValues } from "components/filters/FilterContext";
import { mapOwnersFilterToInstruction, mapResponseToAppointmentPhaseFilter, mapResponseToOwnerFilter } from "components/filters/mappingUtils";

export const mapFilterValuesToInstruction = (
  filterSet: server.dto.FilterSets,
  filter: FilterValues,
  page: number,
  perPage: number
): server.dto.ListExtractorSessionInstruction => ({
  ownerUserIds: mapOwnersFilterToInstruction(filter.owners),
  page,
  perPage,
  cache: filterSet
});

export const mapResponseToFilterValues = (
  response: server.dto.ListExtractorSessionFilters,
  _: FilterValues
): Partial<FilterValues> => ({
  owners: mapResponseToOwnerFilter(response.ownerUsers),
  appointmentPhase: mapResponseToAppointmentPhaseFilter(response.phases)
});